import React, { useEffect } from "react";
import {Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./pages/Home/Home";
import ProductPage from "./pages/ProductPage/ProductPage";
import LayoutPage from "./pages/LayoutPage/LayoutPage";
import CMSLayout from "./pages/AdminPage/CMSLayout";
import CollectionProductPage from "./pages/CollectionProductPage/CollectionPage";
import Dashboard from "./Components/CMS/Dashboard/Dashboard";
import CollectionList from "./Components/CMS/Collection/CollectionList";
import CollectionAdd from "./Components/CMS/Collection/CollectionAdd";
import CollectionEdit from "./Components/CMS/Collection/CollectionEdit";
import ProductList from "./Components/CMS/Product/ProductList";
import ProductAdd from "./Components/CMS/Product/ProductAdd";
import ProductEdit from "./Components/CMS/Product/ProductEdit";
import AllProductPage from "./pages/AllProductPage/AllProductPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import AboutUs from "./pages/AboutPage/AboutUs";
import CheckOutPage from "./pages/CheckOutPage/CheckOutPage";
import MyAccountPage from "./pages/MyAccountPage/MyAccountPage";
import PaymentResult from "./pages/PaymentResult/PaymentResult";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import OrdersList from "./Components/CMS/Orders/OrdersList";
import AdminOrdersView from "./Components/CMS/Orders/AdminOrdersView";
import GalleryPage from "./pages/GalleryPage/GalleryPage";
import FeatuedProductList from "./Components/CMS/featuedProduct/FeatuedProductList";
import FeatuedProductAdd from "./Components/CMS/featuedProduct/FeatuedProductAdd";
import FeatuedProductEdit from "./Components/CMS/featuedProduct/FeatuedProductEdit";
import BannersList from "./Components/CMS/Banners/BannersList";
import BannersAdd from "./Components/CMS/Banners/BannersAdd";
import BannersEdit from "./Components/CMS/Banners/BannersEdit";
import { useDispatch } from "react-redux";
import BannersReorder from "./Components/CMS/Banners/BannerReorder";
import GalleryList from "./Components/CMS/Gallery/GalleryList";
import GalleryAdd from "./Components/CMS/Gallery/GalleryAdd";
import AllCollectionPage from "./pages/AllCollectionPage/AllCollectionPage";
import CustomerGalleryList from "./Components/CMS/CustomerGallery/CustomerGalleryList";
import CustomerGalleryAdd from "./Components/CMS/CustomerGallery/CustomerGalleryAdd";
import Promo from "./Components/CMS/Promo/Promo";
import PromoAdd from "./Components/CMS/Promo/PromoAdd";
import PromoEdit from "./Components/CMS/Promo/PromoEdit";
import OrderManualForm from "./Components/CMS/Orders/OrderManualForm";
import AnalyticsTracker from "./Components/AnalyticsTracker/AnalyticsTracker";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { setLoggedInUser } from "./reducer/user.reducer";
import AdminRoute from "./config/rbac.config";
import RoleGuard from "./config/RoleGuard";
import UserList from "./Components/CMS/User/UserList.jsx";

const App = ({ isCartActive, toogleCart}) => {

  const dispatch = useDispatch()
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdToken();
        localStorage.setItem("_at", token);
        dispatch(setLoggedInUser({
          uid: user.uid,
          email: user.email,
          name: user.displayName,
          image: user.photoURL
        }));
      } else {
        localStorage.removeItem("_at");
        dispatch(setLoggedInUser(null));
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return (
    <div>
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
      />
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<LayoutPage />}>
          <Route index element={<Home />} />
          <Route path="product/:slug/:id" element={<ProductPage isCartActive={isCartActive} toogleCart={toogleCart}/>}/>
          <Route path="collection/:slug/:id" element={<CollectionProductPage />} />
          <Route path="all_product" element={<AllProductPage />} />
          <Route path="gallery" element={<GalleryPage />} /> 
          <Route path="login" element={<LoginPage/>}/>
          <Route path="contact" element={<ContactPage/>}/>
          <Route path="about_us" element={<AboutUs/>}/>
          <Route path="check_out" element={<CheckOutPage isCartActive={isCartActive} toogleCart={toogleCart}/>}/>              
          <Route path='/my_account' element={<MyAccountPage/>}/>      
          <Route path='/all_collection' element={<AllCollectionPage/>}/>       
          <Route path='/payment/success' element={<PaymentResult/>}/>
          <Route path='/payment/failure' element={<PaymentResult/>}/>
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route path="/dashboard" element={<AdminRoute allowedRole={["admin", "staff"]}> <CMSLayout /> </AdminRoute>}>
          {/* admin routes down */}
          <Route index element={<RoleGuard allowedRoles={["admin"]}><Dashboard defaultTab="overview" /></RoleGuard>} />
          <Route path="sales-analytics" element={<RoleGuard allowedRoles={["admin"]}><Dashboard defaultTab="sales" /></RoleGuard>} />
          <Route path="product-analytics" element={<RoleGuard allowedRoles={["admin"]}><Dashboard defaultTab="products" /></RoleGuard>} />
          <Route path="expense-management" element={<RoleGuard allowedRoles={["admin"]}><Dashboard defaultTab="expenses" /></RoleGuard>} />
          <Route path="website-analytics" element={<RoleGuard allowedRoles={["admin"]}><Dashboard defaultTab="website" /></RoleGuard>} />
          <Route path="userList" element={<RoleGuard allowedRoles={["admin"]}><UserList /></RoleGuard>} />
          <Route path="collection" element={<RoleGuard allowedRoles={["admin"]}><CollectionList /></RoleGuard>} />
          <Route path="add_collection" element={<RoleGuard allowedRoles={["admin"]}><CollectionAdd /></RoleGuard>} />
          <Route path="edit_collection/:id" element={<RoleGuard allowedRoles={["admin"]}><CollectionEdit /></RoleGuard>} />
          <Route path="product" element={<RoleGuard allowedRoles={["admin"]}><ProductList /></RoleGuard>} />
          <Route path="add_product" element={<RoleGuard allowedRoles={["admin"]}><ProductAdd /></RoleGuard>} />
          <Route path="edit_product/:id" element={<RoleGuard allowedRoles={["admin"]}><ProductEdit /></RoleGuard>} /> 
          <Route path="banners" element={<RoleGuard allowedRoles={["admin"]}><BannersList /></RoleGuard>} />
          <Route path="add_banners" element={<RoleGuard allowedRoles={["admin"]}><BannersAdd /></RoleGuard>} />
          <Route path="edit_banners/:id" element={<RoleGuard allowedRoles={["admin"]}><BannersEdit /></RoleGuard>} />
          <Route path="reorder_banners/" element={<RoleGuard allowedRoles={["admin"]}><BannersReorder /></RoleGuard>} />
          <Route path='order_list' element={<OrdersList/>}/>
          <Route path='order_view/:id' element={<AdminOrdersView/>}/>
          <Route path='order_edit/:id' element={<AdminOrdersView defaultEdit={true}/>}/>
          <Route path= 'featured_product' element = {<RoleGuard allowedRoles={["admin"]}><FeatuedProductList/></RoleGuard>}/>
          <Route path= 'featured_product_add' element = {<RoleGuard allowedRoles={["admin"]}><FeatuedProductAdd/></RoleGuard>}/>
          <Route path= 'featured_product_edit/:id' element = {<RoleGuard allowedRoles={["admin"]}><FeatuedProductEdit/></RoleGuard>}/>
          <Route path= 'gallery' element = {<RoleGuard allowedRoles={["admin"]}><GalleryList/></RoleGuard>}/>
          <Route path= 'gallery_add' element = {<RoleGuard allowedRoles={["admin"]}><GalleryAdd/></RoleGuard>}/>
          <Route path= 'customerGallery' element = {<RoleGuard allowedRoles={["admin"]}><CustomerGalleryList/></RoleGuard>}/>
          <Route path= 'customerGallery_add' element = {<RoleGuard allowedRoles={["admin"]}><CustomerGalleryAdd/></RoleGuard>}/>
          <Route path='promo_code' element={<RoleGuard allowedRoles={["admin"]}><Promo/></RoleGuard>}/>
          <Route path='promo_code_add' element={<RoleGuard allowedRoles={["admin"]}><PromoAdd/></RoleGuard>}/>
          <Route path='promo_code_edit/:id' element={<RoleGuard allowedRoles={["admin"]}><PromoEdit/></RoleGuard>}/> 
          <Route path='add_manual_order' element={<OrderManualForm/>}/>
        </Route>
      </Routes>
    </div>
  );
};

export default App;
